// extracted by mini-css-extract-plugin
export default {"welcomeHeader":"style_welcomeHeader__vi22V","welcomeHeaderLogo":"style_welcomeHeaderLogo__H8Hwa","profileWrapper":"style_profileWrapper__fY+s0"};